module.exports = __webpack_public_path__ + "img/josiah-henson.1cf62c38.png";